  <!-- <img src="../assets/hospital.jpg" width="260px"> -->
  <!-- <img class="bg-class" src="./assets/hospital.jpg"> -->
  <div class="background-container">
    <img src="./assets/hospital.png" alt="Hospital Background" class="background-image-hospital">
    <img src="./assets/NN.png" alt="Your New Background Image" class="background-image-new">
    <div class="chat-container">
  <div class="chat-header">
    NURSE NAVIGATOR
  </div>
  <div class="chat-messages" id="chatMessages">

    <ng-container *ngIf="chatHistory.length === 0">
      <img src="./assets/message-bg.png" alt="Empty Chat Image" class="empty-chat-image">
    </ng-container>
    <!-- Chat messages will appear here -->
    <div *ngFor="let message of chatHistory" [ngClass]="{'user-message': message.role === 'user', 'bot-message': message.role === 'assistant'}">
      <ng-container *ngIf="message.role === 'assistant'; else userMessage">
        <strong>Assistant:<br/></strong> {{ message.content }}
      </ng-container>
      <ng-template #userMessage>
        <strong>You:<br/></strong> {{ message.content }}
      </ng-template>
    </div>
    <div class="loading" *ngIf="loading">Loading...</div>
  </div>
  <div class="input-container">
    <input type="text" class="input-box" #userInput placeholder="Type your Message..." (keyup.enter)="userInput.value && sendMessage(userInput.value); userInput.value=''">
    <button class="send-button" (click)="sendMessage(userInput.value); userInput.value=''">Send</button>
  </div>
</div>
</div>
